var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuppAcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2305 68.25C9.00047 68.25 7.98047 67.23 7.98047 66C7.98047 53.19 20.5505 42.75 36.0006 42.75C39.0306 42.75 42.0006 43.14 44.8806 43.95C46.0806 44.28 46.7706 45.51 46.4406 46.71C46.1106 47.91 44.8806 48.6 43.6806 48.27C41.2206 47.58 38.6406 47.25 36.0006 47.25C23.0405 47.25 12.4805 55.65 12.4805 66C12.4805 67.23 11.4605 68.25 10.2305 68.25Z",
    fill: "#19295C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38.25C26.49 38.25 18.75 30.51 18.75 21C18.75 11.49 26.49 3.75 36 3.75C45.51 3.75 53.25 11.49 53.25 21C53.25 30.51 45.51 38.25 36 38.25ZM36 8.25C28.98 8.25 23.25 13.98 23.25 21C23.25 28.02 28.98 33.75 36 33.75C43.02 33.75 48.75 28.02 48.75 21C48.75 13.98 43.02 8.25 36 8.25Z",
    fill: "#19295C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 68.25C50.46 68.25 47.1 66.93 44.49 64.56C43.44 63.66 42.51 62.55 41.79 61.32C40.47 59.16 39.75 56.61 39.75 54C39.75 50.25 41.19 46.74 43.77 44.07C46.47 41.28 50.1 39.75 54 39.75C58.08 39.75 61.95 41.49 64.59 44.49C66.93 47.1 68.25 50.46 68.25 54C68.25 55.14 68.1 56.28 67.8 57.36C67.5 58.71 66.93 60.12 66.15 61.35C63.66 65.61 58.98 68.25 54 68.25ZM54 44.25C51.33 44.25 48.87 45.3 47.01 47.19C45.24 49.02 44.25 51.42 44.25 54C44.25 55.77 44.73 57.51 45.66 59.01C46.14 59.85 46.77 60.6 47.49 61.23C49.29 62.88 51.6 63.78 54 63.78C57.39 63.78 60.6 61.98 62.34 59.07C62.85 58.23 63.24 57.27 63.45 56.34C63.66 55.56 63.75 54.81 63.75 54.03C63.75 51.63 62.85 49.32 61.23 47.52C59.43 45.42 56.79 44.25 54 44.25Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4993 56.1895H49.5293C48.2993 56.1895 47.2793 55.1695 47.2793 53.9395C47.2793 52.7095 48.2993 51.6895 49.5293 51.6895H58.4993C59.7293 51.6895 60.7493 52.7095 60.7493 53.9395C60.7493 55.1695 59.7293 56.1895 58.4993 56.1895Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppAcc);
export default __webpack_public_path__ + "static/media/suppAcc.7fd6da486e9932069bd152f155db1178.svg";
export { ForwardRef as ReactComponent };